import axios from '@/utils/api'

export const getMxColony = function ({ commit, state, dispatch, getters }, zip) {
  if (!state.history[state.currentStep].field['game-type'] || state.history[state.currentStep].field['game-type'] === 'preloader') { return } // user type very fast
  commit('CHANGE_PRELOADER', true)
  let fields = ['colony', 'city', 'municipality', 'state']
  axios({
    method: 'GET',
    url: `${state.backendUrl}/address/mx?zip=${zip}`,
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    let colonies = response.data.data.colonies
    if (colonies.length === 1) {
      for (let i in fields) {
        dispatch('insertOrUpdateField', {
          index: state.currentStep + 1 + +i,
          data: { name: fields[i], isValid: true, value: colonies[0][fields[i]], skip: true }
        })
      }
      commit('CHANGE_PRELOADER', false)
      dispatch('changeStep', +1)
    } else {
      let translate = {}
      let additionalColonyInfo = {}
      let colonyConfig = getters.getFieldInfoByName('colony')
      for (let i in colonies) {
        translate[colonies[i].colony] = colonies[i].colony
        additionalColonyInfo[colonies[i].colony] = colonies[i]
      }
      colonyConfig['translate'] = translate
      colonyConfig['additionalColonyInfo'] = additionalColonyInfo
      for (let i in fields) {
        let data = { name: fields[i], skip: false }
        if (fields[i] === 'colony') data.field = colonyConfig
        dispatch('insertOrUpdateField', {
          index: state.currentStep + 1 + +i,
          data: data
        })
      }
      commit('CHANGE_PRELOADER', false)
      dispatch('changeStep', +1)
    }
  }, (error) => {
    console.log(error.response)
    let invalidValues = state.history[state.currentStep].invalidValues || []
    invalidValues.push(zip)
    commit('UPDATE_FIELD', { isValid: false, showError: true, invalidValues: invalidValues })
    commit('CHANGE_PRELOADER', false)
  })
}

export const getEsCity = function ({ commit, state, dispatch, getters }, province) {
  commit('CHANGE_PRELOADER', true)
  axios({
    method: 'GET',
    url: `${state.backendUrl}/address/es/city?province=${province}`,
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    let cities = response.data.data.city
    let cityConfig = getters.getFieldInfoByName('city')
    cityConfig['values'] = cities
    dispatch('insertOrUpdateField', {
      index: state.currentStep + 1,
      data: { name: 'city', field: cityConfig }
    })
    commit('CHANGE_PRELOADER', false)
    dispatch('changeStep', +1)
  }, () => {
    setTimeout(() => {
      dispatch('getEsCity', province)
    }, 500)
  })
}

export const getEsZip = function ({ commit, state, dispatch, getters }, city) {
  commit('CHANGE_PRELOADER', true)
  axios({
    method: 'GET',
    url: `${state.backendUrl}/address/es/zip?city=${city}`,
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    let delta = +1
    let zips = response.data.data.zip
    let zipConfig = getters.getFieldInfoByName('zip')
    zipConfig['values'] = zips
    let data = { name: 'zip', field: zipConfig }
    if (zips.length === 1) {
      data.value = zips[0]
      data.isValid = true
      delta += 1
    }
    dispatch('insertOrUpdateField', {
      index: state.currentStep + 1,
      data: data
    })
    commit('CHANGE_PRELOADER', false)
    dispatch('changeStep', +delta)
  }, () => {
    setTimeout(() => {
      dispatch('getEsZip', city)
    }, 500)
  })
}

export const getPlCity = function ({ commit, state, dispatch, getters }, { zip, prefix }) {
  if (!state.history[state.currentStep].field['game-type'] || state.history[state.currentStep].field['game-type'] === 'preloader') { return } // user type very fast
  commit('CHANGE_PRELOADER', true)
  let fields = ['state', 'city']
  axios({
    method: 'GET',
    url: `${state.backendUrl}/address/pl?zip=${zip.split('-').join('')}`,
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    const variants = response.data.data.states
    if (variants.length === 1) {
      for (let i in fields) {
        const nameWithPrefix = prefix + fields[i]
        dispatch('insertOrUpdateField', {
          index: state.currentStep + 1 + +i,
          data: { name: nameWithPrefix, isValid: true, value: variants[0][fields[i]], skip: true }
        })
      }
      commit('CHANGE_PRELOADER', false)
      dispatch('changeStep', +1)
    } else {
      for (let i in fields) {
        const nameWithPrefix = prefix + fields[i]
        console.log(prefix, fields[i], nameWithPrefix)
        let data = { name: nameWithPrefix, skip: false }
        if (nameWithPrefix.includes('city')) {
          let cityConfig = getters.getFieldInfoByName(nameWithPrefix)
          if (!cityConfig.translate) cityConfig.translate = {}
          for (let i in variants) {
            cityConfig.translate[variants[i].city] = variants[i].city
          }
          data.field = cityConfig
        } else if (nameWithPrefix.includes('state')) {
          data.skip = true
          data.value = variants[0].state
        }
        dispatch('insertOrUpdateField', {
          index: state.currentStep + 1 + +i,
          data: data
        })
      }
      commit('CHANGE_PRELOADER', false)
      dispatch('changeStep', +1)
    }
  }, (error) => {
    console.log(error.response)
    let invalidValues = state.history[state.currentStep].invalidValues || []
    invalidValues.push(zip)
    commit('UPDATE_FIELD', { isValid: false, showError: true, invalidValues: invalidValues })
    commit('CHANGE_PRELOADER', false)
  })
}



// WEBPACK FOOTER //
// ./src/store/helpers/geo-actions.js